<div
  class="mat-secondary-text flex items-center justify-center text-center flex-col h-[calc(100vh-4rem)]"
>
  <div class="mat-headline-1 mb-4">Page Not Found</div>

  <div class="mat-body">But watame did nothing wrong.</div>
</div>
